import React from 'react';
import AdminPostManagementComponent from '../../../components/admin/community/AdminPostManagementComponent';

const AdminPostManagement: React.FC = () => {
  return <AdminPostManagementComponent />;
};

export default AdminPostManagement;
